import Instance from "../../../../Axios";

// New Actions for the app

const GetCredNotificacoes = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/notificacoes`)
    .then(({ data }) => {
      dispatch({ type: "GET_CRED_NOTIFICACOES", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredNotificacoes;